import { useTripSync } from "@/hooks/use-trip-sync"

// init cross-tab sync for trip data
export function TripSyncProvider() {
  useTripSync()
  return null
}
